var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "k-page",
    { staticClass: "page-not-found" },
    [
      _c(
        "d-main-image",
        _vm._b(
          { on: { load: _vm.pageLoaded } },
          "d-main-image",
          { img: _vm.img, show: _vm.show },
          false
        )
      ),
      _c("w-go-down"),
      _c(
        "k-main",
        { attrs: { title: "Page Not Found" } },
        [
          _c("div", { staticClass: "message" }, [
            _vm._v("Very sorry! We couldn't find that page."),
          ]),
          _vm.q
            ? _c(
                "w-btn",
                {
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.retry.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("Try Again")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }